import { useState } from 'react';

import { DialogNugget, PanelNugget } from '@backrs_ui/common-ui';

import { handleBookmark } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavContact } from '@backrs_ui/grow-ui/src/models/models';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectBookmarkedNuggetId } from '@backrs_ui/grow-ui/src/redux/user/user';

import { Dialog } from '@mui/material';

const APP_URL = process.env.REACT_APP_GROW_URL;

type GetShareUrlProps = Readonly<{
  link?: string;
  userId?: string;
  type: ContactsFormatterProps['type'];
}>;

const getShareUrl = ({ link, userId, type }: GetShareUrlProps) => {
  if (type === 'profile-internal') {
    return `${APP_URL}?profile-in=${userId}`;
  }

  return link || '';
};

type ContactsFormatterProps = Readonly<{
  contact: LubavContact;
  type: 'profile-internal' | 'profile-external';
  disableExpansion?: boolean;
}>;

export const ContactsFormatter = ({
  contact,
  type,
  disableExpansion = false,
}: ContactsFormatterProps) => {
  const [open, setOpen] = useState(false);
  const [activeDialogNugget, setActiveDialogNugget] = useState<LubavContact | null>(null);

  const bookmarkId = useAppSelector(
    selectBookmarkedNuggetId({
      nuggetId: Number(activeDialogNugget?.id),
      variant: type,
    }),
  );

  const dispatch = useAppDispatch();

  const handleClick = () => {
    setActiveDialogNugget(contact);
    setOpen(true);
  };

  const dialogNugget = activeDialogNugget ? (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
      <DialogNugget
        title={`Connect with and Review ${activeDialogNugget?.metadata?.name}'s Profile`}
        shareParams={
          APP_URL && type === 'profile-internal'
            ? {
                title: `Prosper: ${activeDialogNugget.metadata?.name}`,
                text: `Prosper: Connect with and Review ${activeDialogNugget?.metadata?.name}'s Profile`,
                url: getShareUrl({
                  userId: activeDialogNugget.id,
                  link: activeDialogNugget.metadata?.link,
                  type,
                }),
              }
            : undefined
        }
        variant={{
          type,
          abbreviatedName: activeDialogNugget?.metadata?.name,
          location: activeDialogNugget?.metadata?.location,
          jobTitle: activeDialogNugget?.metadata?.job_title,
          employer: activeDialogNugget?.metadata?.employer,
          school: activeDialogNugget?.metadata?.school || undefined,
          role: activeDialogNugget?.metadata?.role,
          profileImageUrl: contact.metadata.profile_image || 'profile-pics/default.svg',
          linkToProfile: activeDialogNugget?.metadata?.link,
        }}
        description={activeDialogNugget?.relevance || ''}
        columnCategory={'Connect'}
        saveToLibrary={
          type === 'profile-internal' && Number(activeDialogNugget.id)
            ? () =>
                handleBookmark({
                  nuggetId: Number(activeDialogNugget.id),
                  dispatch,
                  bookmarkId,
                  variant: type,
                })
            : undefined
        }
        hasBookmarkedNugget={!!bookmarkId}
      />
    </Dialog>
  ) : null;

  return (
    <>
      {dialogNugget}
      <PanelNugget
        key={contact.metadata?.name}
        title={`Profile: ${contact.metadata?.name}`}
        body={contact.relevance}
        variant={{
          type,
          profileImageUrl: contact.metadata.profile_image || '/profile-pics/default.svg',
          abbreviatedName: contact.metadata?.name,
          location: contact.metadata?.location,
          jobTitle: contact.metadata?.job_title,
          employer: contact.metadata?.employer,
          school: contact.metadata?.school || undefined,
          role: contact.metadata?.role,
        }}
        size="SMALL"
        {...(!disableExpansion && { onClick: handleClick })}
      />
    </>
  );
};
